import { render } from "./CurrentMeasurement.vue?vue&type=template&id=31f2d396&scoped=true"
import script from "./CurrentMeasurement.vue?vue&type=script&lang=js"
export * from "./CurrentMeasurement.vue?vue&type=script&lang=js"

import "./CurrentMeasurement.vue?vue&type=style&index=0&id=31f2d396&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f2d396"]])

export default __exports__